module.exports = __webpack_public_path__ + "static/media/27 - Africa Express - Johannesburg.c10be87b.mp3";